import { Link } from '@inertiajs/react'
import { Organization } from "@/types";

interface OrganizationListItemProps {
    organization: Organization
}

export default function OrganizationListItem({organization}: OrganizationListItemProps) {
    return (
        <li>
            <div className="px-4 py-4 sm:px-6">
                <div className="flex items-center justify-between">
                    <div className="flex items-center">
                        <div>
                            <Link
                                href={`/admin/organizations/${organization.id}`}
                                className="text-lg font-medium text-indigo-600 hover:text-indigo-700 hover:underline truncate"
                            >
                                {organization.name}
                            </Link>
                            <p className="text-sm text-gray-500">
                                Slug: {organization.slug}
                            </p>
                        </div>
                    </div>
                    <div className="flex items-center space-x-4">
                        <div className="text-right">
                            <p className="text-sm font-medium text-gray-900">
                                {organization.users_count} users
                            </p>
                            <p className="text-sm text-gray-500">
                                Created {organization.created_at}
                            </p>
                        </div>

                        <div className="flex items-center space-x-2">
                            <Link
                                href={`/admin/organizations/${organization.id}`}
                                className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            >
                                View Details
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    )
}